import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppInit } from '@us/web/shared/app';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { PromotionsService } from '../services/promotions.service';
import { PromotionsActions } from './promotions.actions';
import { getErrorMessage, PROMOTION_WEBORDER } from '@us/web/shared/utils';

@Injectable()
export class PromotionsEffects {
    private readonly actions$ = inject(Actions);
    private readonly promotionsService = inject(PromotionsService);

    loadPromotions$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(PromotionsActions.loadPromotions),
            concatMap(({ shopId, customer_phone }) => {
                return this.promotionsService
                    .getPromotions({
                        shop_id: shopId,
                        with_details: 1,
                        is_actived_flg: 1,
                        target_channels: PROMOTION_WEBORDER,
                        is_new: 1,
                        customer_phone
                    })
                    .pipe(
                        map(promotions => PromotionsActions.loadPromotionsSuccess({ promotions })),
                        catchError(error =>
                            of(PromotionsActions.loadPromotionsFailure({ error: getErrorMessage(error) }))
                        )
                    );
            })
        );
    });
}
